import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.page.html',
  styleUrls: ['./login-layout.page.scss'],
})
export class LoginLayoutPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
